var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { gql } from '@apollo/client/core';
import * as AccountConfig from './AccountConfig';
const ACCOUNT_CONFIG_QUERY = gql `
  query AccountConfig {
    app {
      accountConfig {
        id
        name
        features {
          name
          enabled
        }
      }
    }
  }
`;
export const fetchAccountConfig = (client) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield client.query({
        query: ACCOUNT_CONFIG_QUERY,
        fetchPolicy: 'network-only',
    });
    return AccountConfig.fromGql(data.app.accountConfig);
});
//# sourceMappingURL=Api.js.map